import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { NewAccountSvg } from '@cashier/cashier-assets';
import {
  Directions,
  FormField,
  IntegrationThemes,
} from '@cashier/cashier-model';
import { cn, Select } from '@cashier/cashier-ui';

import { useCashierConfiguration } from '../../../hooks';
import { useAccountSelect } from '../hooks';

import styles from './styles.module.scss';

interface AccountSelectProps {
  field: FormField;
  version: 'v2' | 'v3';
}

export const AccountSelect = ({
  field,
  version,
}: AccountSelectProps): ReactElement => {
  const { t } = useTranslation();

  const { params, name, value, isDisabled: isFieldDisabled } = field;
  const containerStyles =
    version === 'v2' ? styles.container : styles.parentContainer;

  const { options } = params || {};

  const { direction } = useCashierConfiguration();
  const { isDisabled, onChange, onReset } = useAccountSelect(field);

  return (
    <div className={containerStyles}>
      <Select
        name={name}
        options={options || []}
        onChange={(value) => onChange(value)}
        defaultValue={value ? (value as string) : undefined}
        label={t('selectAccount.label')}
        theme={IntegrationThemes.Platform}
        direction={direction}
        isDisabled={isFieldDisabled || isDisabled}
        version={version}
      />
      <div
        className={cn({
          [styles.addNew]: true,
          [styles.rtl]: direction === Directions.Rtl,
          [styles.selfIcon]: version === 'v2',
          [styles.parentIcon]: version === 'v3',
          [styles.topMargin]: version === 'v3',
        })}
        onClick={onReset}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            onReset();
          }
        }}
        data-test="add-account-button"
      >
        <NewAccountSvg />
      </div>
    </div>
  );
};
